import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import MinimalDumbo from '../MinimalDumbo';
import TextRenderer from '../../../TextRenderer';
import PollAnswerViewer from '../../../DaEditorWrapper/Viewer/PollAnswer';
import pollStyles from './Poll.scss';
var Answer = function (_a) {
    var textContent = _a.textContent, image = _a.image, answerId = _a.answerId, percentvotes = _a.percentvotes;
    return (React.createElement("li", { className: classnames(pollStyles['answer'], pollStyles['answer-voted']) },
        React.createElement("div", { className: pollStyles['answer-row'] },
            image && (React.createElement(MinimalDumbo, { deviation: image, className: pollStyles['pollimage'], width: 72, height: 72 })),
            React.createElement(TextRenderer, { htmlExcerptLegacy: true, isPollWithHtmlExcerpt: true, textContent: textContent, className: classnames(pollStyles['answer-text'], 'da-editor-poll-thumb'), reactViewer: PollAnswerViewer, viewerKey: answerId }),
            React.createElement("div", { className: pollStyles['percent'] },
                percentvotes,
                "%")),
        React.createElement("div", { className: pollStyles['bar-wrapper'] },
            React.createElement("div", { className: pollStyles['bar'], style: { width: "".concat(percentvotes, "%") } }))));
};
var VotedAnswers = function (_a) {
    var poll = _a.poll;
    return (React.createElement("ul", { className: classnames(pollStyles['voted'], pollStyles['answers']) }, poll.answers.map(function (answer) { return (React.createElement(Answer, __assign({}, answer, { key: "answer:".concat(answer.answerId) }))); })));
};
export default VotedAnswers;
//# sourceMappingURL=VotedAnswers.js.map